import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { getFieldCalculation } from '../../../modules/forms/utils/helpers';

class NumberFormats extends Component {
  constructor(props) {
    super(props);
    const { isRequired, updateFieldErrors, answer, default_number, fieldId } = this.props;

    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    if (default_number && fieldId && !answer) {
      this.handleAnswerChanged({ value: default_number }, fieldId);
    }
  }

  handleCalculation = () => {
    const { fields, answers, fromMultiGrid, allFields, handleValueChange, multiFieldId } = this.props;
    let calculation = '';
    let formula = '';
    if (fromMultiGrid) {
      const multiGridFields = allFields?.filter(e => e.type === 'multi_field');
      if (multiGridFields) {
        multiGridFields.forEach((e) => {
          const multipleFields = Object.keys(e?.multiple_fields)?.map(i => ({ ...e?.multiple_fields[i], id: i }));
          const calcFields = multipleFields?.filter(field => field?.type?.key === 'calculation');
          const numberFields = multipleFields?.filter(field => field?.type?.key === 'number');
          if (calcFields?.length > 0) {
            let result = {};
            let resultArray = [];
            calcFields.forEach(async (field) => {
              formula = field.calculation;
              // eslint-disable-next-line no-useless-escape
              const formulaValues = formula?.replace(/\s+/g, '')?.split(/([()\+\-\*\/])/)?.filter(arr => arr!=='') || [];
              const formulaValueArray = numberFields?.filter(num => formulaValues?.filter(
                arr => ((num.calc_field_id === arr) || (num.id === arr))
              )?.length > 0);
              if (formulaValueArray?.length > 0) {
                resultArray = formulaValueArray?.map((num) => {
                  result[num.calc_field_id || num.id] = answers[num.id];
                  return result;
                });
              }
              const answerValues = resultArray?.length > 0 ? resultArray?.[0] : answers;
              calculation = await getFieldCalculation(formula, answerValues);
              if (multiFieldId?.id === e?.id) {
                handleValueChange(calculation, field.id);
              }
            });
          }
        });
      }
    } else {
      const calculationFields = fields?.filter(field => field.type === 'calculation') || [];
      const numberFields = fields?.filter(field => field.type === 'number');
      if (calculationFields?.length > 0) {
        let result = {};
        let resultArray = [];
        calculationFields.map((field) => {
          formula = field.meta_data?.form_calculation?.calculation;
          // eslint-disable-next-line no-useless-escape
          const formulaValues = formula?.replace(/\s+/g, '')?.split(/([()\+\-\*\/])/)?.filter(arr => arr!=='') || [];
          const formulaValueArray = numberFields?.filter(num => formulaValues?.filter(
                                    arr => ((num.meta_data.calc_field_id === arr) || (num.id === arr))
                                    )?.length > 0);
          if (formulaValueArray?.length > 0) {
            resultArray = formulaValueArray?.map((num) => {
              result[num.meta_data.calc_field_id || num.id] = answers[num.id];
              return result;
                });
          }
          const answerValues = resultArray?.length > 0 ? resultArray?.[0] : answers;
          calculation = getFieldCalculation(formula, answerValues);
          return handleValueChange(calculation, field.id);
        });
      }
    }
  }


  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, fromwo
    } = this.props;
    handleValueChange(value.value, fieldId);
    let updatedErrors = [];

    if (value.value === '' || value.value === undefined || (fromwo && parseFloat(value.value) <=0)) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { fieldId, answer, placeHolderValue, thousandSeparator, prefix,
      suffix, format, disabled, decimalDigits } = this.props;
    return (
      <NumberFormat
        thousandSeparator={thousandSeparator}
        prefix={prefix}
        suffix={suffix}
        allowNegative={false}
        displayType="input"
        name={`format-field-${fieldId}`}
        onValueChange={e => this.handleAnswerChanged(e, fieldId)}
        onBlur={this.handleCalculation}
        value={answer} disabled={disabled}
        type="text"
        placeHolder={placeHolderValue}
        format={format}
        decimalScale={decimalDigits}
      />
    );
  }
}


NumberFormats.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

NumberFormats.defaultProps = {
  answer: ''
};

export default NumberFormats;
